import { render, staticRenderFns } from "./ReferenceTableActions.vue?vue&type=template&id=6a36e932&"
import script from "./ReferenceTableActions.vue?vue&type=script&lang=js&"
export * from "./ReferenceTableActions.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTableActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports